import { render, staticRenderFns } from "./setGoodsList.vue?vue&type=template&id=23acb6ce&scoped=true&"
import script from "./setGoodsList.vue?vue&type=script&lang=js&"
export * from "./setGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./setGoodsList.vue?vue&type=style&index=0&id=23acb6ce&lang=scss&scoped=true&"
import style1 from "./setGoodsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acb6ce",
  null
  
)

export default component.exports